$(function(){

    $('[js-open-generated-form]').on('click', function(e){
        e.preventDefault();

        $$.openModal($('.modal-'+$(this).data('modal')), {
            afterOpen: function(modal, $modal){
                $modal.find('form').formHandle({
                    success: function(data, $form){

                    }
                })
            }
        });
    });

});